import { ContactList } from "../../modules/authmethods";
import { PhoneNumberEnrolment } from "../../components/PhoneNumberInput"

export const enrolmentToContactList = (pneList: PhoneNumberEnrolment | PhoneNumberEnrolment[]): ContactList => 
    _.castArray(pneList).map(pne => {
      const formatted = pne.phoneNumber.getNumber("international").replace(/\D/g, " ").trim()
      let countryCode = Math.min(formatted.indexOf(" "), 3)
      let areaCode = Math.min(formatted.indexOf(" ", countryCode + 1) - countryCode - 1, 3)
      let numbers = formatted.replace(/\D/g, "")

      return {
        defaultFlag: pne.default,
        label: pne.key,
        phoneNumber: numbers.substr(countryCode+areaCode).trim(),
        countryCode: numbers.substr(0, countryCode),
        areaCode: numbers.substr(countryCode, areaCode),
      }
    }) as ContactList

export const isRequired = (requiredCredentials: any) => 
  requiredCredentials.length > 0 && requiredCredentials.some((c: any) => 
    c.credentialType === "OOBPHONE"
  )